module.exports = __webpack_public_path__ + "static/media/safari-desktop-step-2.8677ca7a.png";